import { ICorporatePartPriceListItem } from 'corporate/types';

export interface IFlatPriceRow {
  _record: ICorporatePartPriceListItem;
  createdAt: string;
  discountIncrease?: number | null;
  endDate?: string | null;
  id: string;
  itemId?: number;
  marginReduction?: number | null;
  maxQuantity?: number | null;
  minQuantity?: number | null;
  recordId: number;
  startDate: string;
  status: string;
  uom?: string;
  userFirstName: string;
  userLastName: string;
}

const toNumberOrNull = (value: string | null | undefined): number | null =>
  value != null && value !== '' ? Number(value) : null;

export const flattenPriceRecords = (
  records?: ICorporatePartPriceListItem[],
  quantityUom?: string
): IFlatPriceRow[] => {
  if (!records?.length) {
    return [];
  }

  return records.flatMap((record) => {
    const parentFields = {
      _record: record,
      createdAt: record.createdAt,
      endDate: record.endDate,
      recordId: record.id,
      startDate: record.startDate,
      status: record.status,
      uom: quantityUom,
      userFirstName: record.userFirstName,
      userLastName: record.userLastName,
    };

    // Emit a synthetic placeholder leaf so a record with no priceItems still
    // renders (and keeps its edit/remove path) instead of vanishing from the table.
    if (!record.priceItems?.length) {
      return [{ ...parentFields, id: `${record.id}-empty` }];
    }

    return record.priceItems.map((item) => ({
      ...parentFields,
      discountIncrease: toNumberOrNull(item.discountIncrease),
      id: `${record.id}-${item.id ?? 'leaf'}`,
      itemId: item.id,
      marginReduction: toNumberOrNull(item.marginReduction),
      maxQuantity: toNumberOrNull(item.maxQuantity),
      minQuantity: toNumberOrNull(item.minQuantity),
    }));
  });
};
